import React from "react";
import { DetailsRowProps, RenderFunction, Theme, ensure } from "sprint-common-web";

import { RecordType } from "../../../common/types/RecordType";
import { AssetItem } from "./AssetItem";

export const renderAssetRow = (rowProps?: DetailsRowProps, defaultRender?: RenderFunction<DetailsRowProps>) => {
    ensure(rowProps);
    ensure(defaultRender);

    const item = rowProps.item as AssetItem;
    const testProps = {
        "data-testid": "table-row",
        "data-testkey": rowProps.item.id
    };

    if (item.details.type === RecordType.Subtitle && item.details.inPreparation) {
        return renderCustomRow({ ...testProps, ...rowProps }, defaultRender, RowType.InPrep);
    }

    return defaultRender({ ...testProps, ...rowProps }, defaultRender);
};

enum RowType {
    InPrep = 1
}

const colorsByRowType = {
    [RowType.InPrep]: Theme.palette.yellow
};

const renderCustomRow = (
    rowProps: DetailsRowProps,
    defaultRender: RenderFunction<DetailsRowProps>,
    type: RowType
): JSX.Element | null => {
    return defaultRender({
        ...rowProps,
        styles: {
            root: {
                userSelect: "auto",
                borderLeft: `4px solid ${colorsByRowType[type]}`
            }
        }
    });
};
